module.exports = "img/flags/JE.cb6a51d.png";